import { render, staticRenderFns } from "./TencentPlayer.vue?vue&type=template&id=7b956222&scoped=true&"
import script from "./TencentPlayer.vue?vue&type=script&lang=js&"
export * from "./TencentPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TencentPlayer.vue?vue&type=style&index=0&id=7b956222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b956222",
  null
  
)

export default component.exports